import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  public static getUserName(): string {
    let username = 'UserNameNotKnown';
    try{
      const token = this.getUserToken();
      if (!token) return username;
      const decodedToken = jwtDecode<any>(token);
      if (decodedToken['first_name']) {
        username = decodedToken['first_name'];
        if (decodedToken['last_name']) {
          username += ` ${decodedToken['last_name']}`;
        }
      }
    } finally {
      return username;
    }
  }

  public static getUserEmail(): string {
    let useremail = 'UserEmailNotKnown';
    try{
      const token = this.getUserToken();
      if (!token) return useremail;
      const decodedToken = jwtDecode<any>(token);
      if (decodedToken['email']) {
        useremail = decodedToken['email'];
      }
    } finally {
      return useremail;
    }
  }

  static isAtECLPlatform(): boolean {
    const eclOrigin = environment.config.ECL_PLATFORM_URL;
    const localToken = window.localStorage.getItem('accessToken');
    const sessionToken = window.sessionStorage.getItem('accessToken');
    if (document.referrer.includes(eclOrigin) && (localToken != null || sessionToken != null)) {
      return true;
    }
    return false;
  }

  public static getUserToken(): string | null {
    const sessionStorage = window.sessionStorage;

    const sessionToken = sessionStorage['accessToken'];

    if (sessionToken != null && sessionToken != '' && !this.isTokenExpired(sessionToken)) {
      return sessionToken!;
    }

    const localStorage = window.localStorage;
    if (
      localStorage['accessToken'] != null &&
      localStorage['accessToken'] != '' &&
      !this.isTokenExpired(localStorage['accessToken'])
    ) {
      return localStorage['accessToken']!;
    }

    const tokenUrlSplit = window.location.href.split('?token=');
    if (tokenUrlSplit.length > 1) {
      let token = tokenUrlSplit[1];
      if (token.includes('&')) {
        token = token.split('&')[0];
      }
      if (!this.isTokenExpired(token)) {
        return token;
      }
    }

    return null;
  }

  public static isTokenExpired(token?: string | null): boolean {
    if (!token) return true;
    const tokenObject = jwtDecode(token!);
    const currentTime = Math.floor(Date.now() / 1000); // JWT exp is in seconds
    if (tokenObject.exp && tokenObject.exp <= currentTime) {
      return true;
    }
    return false;
  }

  public static downloadFileOnWeb(url: string) {
    const link = document.createElement('a');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  public static downloadBlobFileOnWeb(blob: Blob, fileName: string = 'document') {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  public static postDisplaySidePanel(isDisplaying: boolean) {
    const targetOrigin = environment.config.ECL_PLATFORM_URL;
    const data = {
      type: 'display_sidepanel',
      stack: 'angular',
      displaying: isDisplaying,
    };

    if (window.parent !== null) {
      window.parent.postMessage(data, targetOrigin);
    }
  }

  public static runAfterDelay(callback: () => void, delayInMs: number = 800) {
    setTimeout(() => {
      callback();
    }, delayInMs);
  }

  public static formatISODateToDDMMYYYY(isoDate: unknown): string {
    if (typeof isoDate !== 'string') return '-';

    const match = isoDate.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!match) return '-';

    const [, year, month, day] = match;
    return `${day}/${month}/${year}`;
  }
}
